<template>
	<div
		class="modal overlay"
		:class="isShow == true ? 'active' : ''"
		@click.self="modalClose"
	>
		<div class="modal_window">
			<div class="modal_window_head">
				<div class="modal_window_head_title">
					<i class="fas fa-solid fa-pen fa-fw text-color-white2" />
					{{ title }}
					<button type="button" class="circleBtn" @click="modalClose">
						<i class="fa-solid fa-circle-xmark fa-fw" />
					</button>
				</div>
			</div>
			<div class="modal_window_content">
				<TextareaForm
					v-model="initialContent"
					:title="''"
					:required="false"
					:disabled="false"
					:form-class="'w-full min-h-[400px]'"
					:maxlength="1000"
					:error-text="error.content"
					:placeholder="''"
				/>

				<div class="mt-12 flex justify-center">
					<Button
						:button-type="'submit'"
						:button-class="'button-red'"
						:button-icon="'fa-check'"
						:button-text="buttonText"
						@click="store"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
// その他
import Button from "@/components/atoms/Button.vue";
import TextareaForm from "@/components/molecules/form/TextareaForm.vue";
import { useExitPageConfirm } from "@/utils/ExitPageConfirm.js";
import { computed, defineEmits, defineProps, ref, watch } from "vue";
import { useRouter } from "vue-router";
// utils
import scrollControlFunction from "@/utils/ScrollControl.js";
/* ---------------------------------------------------------------------------
    Router
---------------------------------------------------------------------------- */
const router = useRouter();
/* ---------------------------------------------------------------------------
utils
---------------------------------------------------------------------------- */
const { parentScrollUnlock } = scrollControlFunction();
const { enable, disable } = useExitPageConfirm(router);
/* ---------------------------------------------------------------------------
	emits
---------------------------------------------------------------------------- */
const emit = defineEmits(["modalClose", "store"]);
/* ---------------------------------------------------------------------------
	props
---------------------------------------------------------------------------- */
const props = defineProps({
	isModal: Boolean,
	title: String,
	buttonText: String,
	formData: String,
	error: [String, Object]
});
/* ---------------------------------------------------------------------------
	data
---------------------------------------------------------------------------- */
const initialContent = ref(props.formData);
const storeFlag = ref(false);
/* ---------------------------------------------------------------------------
	computed
---------------------------------------------------------------------------- */
const isShow = computed({
	get: () => props.isModal,
	set: value => {
		emit("modalClose", value);
	}
});
/* ---------------------------------------------------------------------------
	watch
---------------------------------------------------------------------------- */
// モーダルの表示状態が変化したときに実行
watch(isShow, newVal => {
	if (newVal) {
		// 警告アラートの処理実装
		enable();
	}
});

watch(
	() => props.formData,
	newVal => {
		initialContent.value = newVal;
	}
);
/* ---------------------------------------------------------------------------
	削除実行
---------------------------------------------------------------------------- */
function store() {
	emit("store", initialContent.value);
	storeFlag.value = true;
	modalClose();
	// 親要素のscroll非表示解除
	parentScrollUnlock();
}
/* ---------------------------------------------------------------------------
	モーダル
---------------------------------------------------------------------------- */
// モーダルを閉じる
function modalClose() {
	if (!storeFlag.value) {
		// 親から渡されたformDataとローカルの初期値を比較
		if (props.formData !== initialContent.value) {
			const confirmClose = window.confirm(
				"変更が保存されていません。モーダルを閉じてもよろしいですか？"
			);

			if (!confirmClose) {
				return;
			} else {
				initialContent.value = "";
				// 警告アラートの処理を削除
				disable();
			}
		}
	}
	storeFlag.value = false;
	isShow.value = false;
	parentScrollUnlock();
	// 警告アラートの処理を削除
	disable();
}

function updateFormData(newContent) {
	emit("update:formData", newContent); // formDataが変更されたら親に通知
}
</script>
